<template>
  <div class="flex flex-wrap home-dashboards">
    <div
      class="w-full search-draft-loading vs-con-loading__container draft-courses"
    >
      <draft-content
        :handleChangePage="handleDraftChangePage"
        :result="draftResult"
        contentType="course"
      />
      
    </div>
    <div
      class="w-1/2 pr-5 search-coming-loading vs-con-loading__container coming-courses"
    >
      <csoon-content
        :handleChangePage="handleComingChangePage"
        :result="comingResult"
        contentType="course"
      />
    </div>
    <div
      class="w-1/2 search-coming-loading vs-con-loading__container coming-learning-paths"
    >
      <csoon-content
        :handleChangePage="handleComingLPsChangePage"
        :result="comingLPsResult"
        contentType="learning path"
      />
    </div>
    <div
      class="w-full search-draft-loading vs-con-loading__container draft-learning-paths"
    >
      <draft-content
        :handleChangePage="handleDraftLPsChangePage"
        :result="draftLPsResult"
        contentType="learning path"
      />
      
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { getBasicData } from '@/utils/mixins.js'
import DraftContent from './components/DraftContent'
import CsoonContent from './components/CSoonContent'

export default {
  components: {
    DraftContent,
    CsoonContent,
  },
  mixins: [getBasicData],
  data: () => {
    return {
      currentDraftCoursesPage: 1,
      currentComingCoursesPage: 1,
      currentDraftLPsPage: 1,
      currentComingLPsPage: 1,
      pageSize: 5,
      draftResult: {
        total: 0,
        items: []
      },
      comingResult: {
        total: 0,
        items: []
      },
      draftLPsResult: {
        total: 0,
        items: []
      },
      comingLPsResult: {
        total: 0,
        items: []
      },
    }
  },
  methods: {
    ...mapActions('courses', ['searchCourses']),
    ...mapActions('lpaths', ['searchLPaths']),
    handleDraftChangePage(page) {
      this.currentDraftCoursesPage = page
      this.draftCourses({
        page: this.currentDraftCoursesPage.toString()
      })
    },
    handleComingChangePage(page) {
      this.currentComingCoursesPage = page
      this.comingCourses({
        page: this.currentComingCoursesPage.toString()
      })
    },
    async draftCourses(payload = {}) {
      payload = {
        ...payload,
        status: 'draft',
        page_size: this.pageSize.toString(),
        ordering: "-modified"
      }
      this.$vs.loading({
        container: '.search-draft-loading',
        scale: 0.6
      })
      const response = await this.search(payload)
      this.$vs.loading.close('.search-draft-loading > .con-vs-loading')
      this.draftResult.total = response.count
      this.draftResult.items = response.results
    },
    async comingCourses(payload = {}) {
      payload = {
        ...payload,
        status: 'coming soon',
        page_size: this.pageSize.toString(),
        ordering: "-modified"
      }
      this.$vs.loading({
        container: '.search-coming-loading',
        scale: 0.6
      })
      const response = await this.search(payload)
      this.$vs.loading.close('.search-coming-loading > .con-vs-loading')
      this.comingResult.total = response.count
      this.comingResult.items = response.results
    },
    async search(payload = {}) {
      try {
        const response = await this.searchCourses(payload)
        return response
      } catch (error) {
        this.showError(error)
      }
    },
    handleDraftLPsChangePage(page) {
      this.currentDraftLPsPage = page
      this.draftLPaths({
        page: this.currentDraftLPsPage.toString()
      })
    },
    handleComingLPsChangePage(page) {
      this.currentComingLPsPage = page
      this.comingLPaths({
        page: this.currentComingLPsPage.toString()
      })
    },
    async draftLPaths(payload = {}) {
      payload = {
        ...payload,
        status: 'draft',
        page_size: this.pageSize.toString(),
        ordering: "-modified"
      }
      this.$vs.loading({
        container: '.search-draft-loading',
        scale: 0.6
      })
      const response = await this.searchLPs(payload)
      this.$vs.loading.close('.search-draft-loading > .con-vs-loading')
      this.draftLPsResult.total = response ? response.count : 0
      this.draftLPsResult.items = response ? response.results : []
    },
    async comingLPaths(payload = {}) {
      payload = {
        ...payload,
        status: 'coming soon',
        page_size: this.pageSize.toString(),
        ordering: "-modified"
      }
      this.$vs.loading({
        container: '.search-coming-loading',
        scale: 0.6
      })
      const response = await this.searchLPs(payload)
      this.$vs.loading.close('.search-coming-loading > .con-vs-loading')
      this.comingLPsResult.total = response ? response.count : 0
      this.comingLPsResult.items = response ? response.results : []
    },
    async searchLPs(payload = {}) {
      try {
        const response = await this.searchLPaths(payload)
        return response
      } catch (error) {
        this.showError(error)
      }
    },
  },

  async mounted() {
    try {
      this.$vs.loading()

      // @mixin
      await this.getBasicData()


      this.$nextTick()
        .then(() => {
          this.$vs.loading.close()
        })
      
      this.draftCourses()
      
      this.comingCourses()

      this.draftLPaths()
      
      this.comingLPaths()
      
      // Load the static filtered searches
    } catch (error) {
      this.$vs.loading.close()
      this.showError(error)
    }
  },
}
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>